var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.567 2.086A2.383 2.383 0 0 0 16.89.4C15.411 0 9.481 0 9.481 0s-5.93 0-7.408.399A2.383 2.383 0 0 0 .396 2.086C0 3.575 0 6.68 0 6.68s0 3.106.396 4.594c.218.821.86 1.441 1.677 1.66 1.479.4 7.408.4 7.408.4s5.93 0 7.41-.4a2.347 2.347 0 0 0 1.676-1.66c.396-1.488.396-4.594.396-4.594s0-3.105-.396-4.594zM7.542 9.5V3.86l4.956 2.82L7.542 9.5z",
    fill: "#fff"
  })));
};
export default SvgIconYoutube;